export default [
  {
    name: 'Можно жить',
    key: 'ready',
  },
  {
    name: 'Нужен ремонт',
    key: 'interiorDecorationRequired',
  },
  {
    name: 'Нужно достроить',
    key: 'unfinished',
  },
  {
    name: 'Нужен капремонт или пора сносить',
    key: 'majorRepairsRequired',
  },
];
